<template>
    <div class="dml-brands" data-t="23">
        <dm-scrollable-list className="dml-brands-banners"
                            innerClassName="dml-brands-banners__list"
                            navClassName="dml-brands-banners__nav"
                            :itemsInViewport="5">
            <template slot="items">
                <li class="dml-brand-banner" v-for="(brand, index) in brandList">
                    <a :href="brand.url"
                       class="dml-brand-banner__wrapper"
                       :rel="brand.rel"
                       :target="brand.target"
                       data-ga="m_home.click_brand"
                       :data-ga-label="`${index + 1}_${brand.name}`"
                       data-t="23.1">
                        <p class="dml-brand-banner__name">{{brand.name}}</p>
                        <div class="dml-brand-banner__media">
                            <img class="dml-brand-banner__image lazy"
                                 src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                 :data-srcset="brand.srcSet"
                                 :alt="brand.name">
                        </div>
                    </a>
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-brands',
        components: {
            'dm-scrollable-list': ScrollableListComponent,
            'dm-icon': IconComponent,
        },
        props: {
            brands: {
                type: Array
            }
        },
        computed: {
            brandList() {
                return this.brands.map(brand => {
                    brand.srcSet = `${brand.pictures.small2x} 2x, ${brand.pictures.small1x} 1x`;
                    return brand;
                })
            }
        },
    };
</script>
